// One-time removal of the scene payload earlier builds persisted. See docs/VIEWER_ASSET_LOADING.md.

export const STORED_SCENE_KEYS = ["viewer-3d-state"];

/**
 * Reading `localStorage` throws when site data is blocked, so the caller never touches it.
 *
 * Reached through `window`, not the bare global: Node 25 defines a global `localStorage` on the
 * server with no storage behind it (no `getItem`), and this runs at module load during SSR.
 */
export function discardStoredScene(): string[] {
  let area: Storage | null = null;
  try {
    area = typeof window === "undefined" ? null : window.localStorage;
  } catch {
    return [];
  }
  // Node 25 defines a global `localStorage` with no Storage methods, which is what server
  // rendering sees under the `.nvmrc` Node; treat it as absent.
  if (!area || typeof area.getItem !== "function") return [];
  return STORED_SCENE_KEYS.filter((key) => {
    if (area.getItem(key) === null) return false;
    area.removeItem(key);
    return true;
  });
}
